// extracted by mini-css-extract-plugin
export default {"base":"Buttons_base__1vFhp","loading":"Buttons_loading__-QMx-","primary":"Buttons_primary__3xGpF","spinAround":"Buttons_spinAround__9+EB2","secondary":"Buttons_secondary__h-3so"};